"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const index_1 = require("../../../index");

const AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

const dayjs_1 = __importDefault(require("dayjs"));

const dayjs_2 = require("../../../utils/dayjs");

const PATTERN = /(?:this)?\s{0,3}(morning|afternoon|evening|night|midnight|noon)(?=\W|$)/i;

class ENCasualTimeParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
  innerPattern() {
    return PATTERN;
  }

  innerExtract(context, match) {
    const targetDate = dayjs_1.default(context.refDate);
    const component = context.createParsingComponents();

    switch (match[1].toLowerCase()) {
      case "afternoon":
        component.imply("meridiem", index_1.Meridiem.PM);
        component.imply("hour", 15);
        break;

      case "evening":
      case "night":
        component.imply("meridiem", index_1.Meridiem.PM);
        component.imply("hour", 20);
        break;

      case "midnight":
        dayjs_2.implyTheNextDay(component, targetDate);
        component.assign("hour", 0);
        component.assign("minute", 0);
        component.assign("second", 0);
        break;

      case "morning":
        component.imply("meridiem", index_1.Meridiem.AM);
        component.imply("hour", 6);
        break;

      case "noon":
        component.imply("meridiem", index_1.Meridiem.AM);
        component.imply("hour", 12);
        break;
    }

    return component;
  }

}

exports.default = ENCasualTimeParser;